import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Dropdown,
  Form,
  FormField,
  Label,
  Icon,
} from "semantic-ui-react";
import SunEditor from "suneditor-react";
import { Timestamp } from "firebase/firestore";
import { ORGAN_TIPS, POST } from "react-lib/apps/segment/sequence/SegmentTarget";
import moment from "moment";
import { UploadBeforeHandler, UploadBeforeReturn } from "suneditor-react/dist/types/upload";
import CardPreviewPost from "./CardPreviewPost";

import { formatDatetime } from "react-lib/utils/dateUtils";

type ContentEditorType = {
  content?: string;
  organTags: string[];
  optionsOrgans: any[];
  updatedAt?: Timestamp;
  updatedBy?: { id: number; name: string };

  id: string;
  runSequence: any;
  publishedAt?: Timestamp;
  publishedVersion: number;
  idxPublishLoading: string;
  idxUnpublishLoading: string;
  idxSaveLoading: string;
  setModalParam: any;
  version: number;
  publishJson: any;
  isEdit: boolean;
};

const ContentEditorPost = (props: ContentEditorType) => {
  const [isEdit, setIsEdit] = useState(false);
  const [version, setVersion] = useState<number | undefined>(0);
  const [isExpanded, setIsExpanded] = useState(false); // เพิ่ม state สำหรับ expand/collapse
  console.log('ContentEditorPost props: ', props);

  useEffect(() => {
    setVersion(props.version);
  }, [props.version]);

  useEffect(() => {
    if (!props.version) setIsExpanded(true);
  });

  const dataURLtoFile = (dataurl: any, filename: string) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = globalThis.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handleChange = useCallback(
    async (content: string) => {
      setIsEdit(true);
      console.log("handleChange: content", content);
      let contentCheck = content;
      if (content === "<div><br></div>") {
        contentCheck = "";
      }

      console.log("handleChange A");
      let value = await props.runSequence({
        sequence: "SegmentTarget",
        action: "UpdateContents",
        content: contentCheck,
        id: props.id,
        type: POST,
      });

      console.log("handleChange value: ", value);
      console.log("handleChange B");
    },
    [props.runSequence, setIsEdit]
  );

  const handleImageUploadError = (errorMessage, result) => {
    console.log("handleImageUploadError", errorMessage, result);
  };

  const handleOnResizeEditor = (height, prevHeight) => {
    console.log("handleOnResizeEditor", height, prevHeight);
  };

  const handleImageUploadBefore = (
    files: File[],
    info: object,
    uploadHandler: UploadBeforeHandler
  ): UploadBeforeReturn | undefined => {
    console.log("uploadHandler: ", uploadHandler);
    console.log("handleImageUploadBefore A");

    // // uploadHandler is a function

    // console.log("handleImageUploadBefore",files, info)

    // uploadHandler(editorResponse)
    console.log("files: ", files);
    props
      .runSequence({
        sequence: "SegmentTarget",
        action: "UpdateContents",
        id: props.id,
        files,
        info,
        type: POST,
      })
      .then((res: any) => {
        console.log("response", res);
        let response = {
          result: [
            {
              url: res?.url,
              name: files[0].name,
              size: files[0].size,
            },
          ],
        };

        uploadHandler(response);
      });
    console.log("handleImageUploadBefore B");

    return undefined;
  };

  // const handleVideoUploadBefore = (files, info, uploadHandler) => {
  //     // uploadHandler is a function
  // 	console.log(files, info)

  //   return
  // }

  const handleImageUpload = async (
    targetImgElement: HTMLImageElement,
    index: number,
    state: string, // "create" | "update" | "delete"
    imageInfo: any,
    remainingFilesCount: number
  ) => {
    console.log("handleImageUpload targetImgElement: ", targetImgElement);
    console.log("handleImageUpload remainingFilesCount: ", remainingFilesCount);
    console.log("handleImageUpload state: ", state);
    console.log("handleImageUpload imageInfo: ", imageInfo);
    console.log("handleImageUpload index: ", index);

    await props.runSequence({
      sequence: "SegmentTarget",
      action: "UpdateContents",
      id: props.id,
      targetImgElement,
      index,
      state, // "create" | "update" | "delete"
      imageInfo,
      type: POST,
    });

    // setContentFile((content) => handleSetContentFile(content, index, state, imageInfo));
  };

  const handleSetContentFile = (content: any[], index: number, state: string, imageInfo: any) => {
    // console.log('handleSetContentFile: ', content);
    // console.log('handleSetContentFile: ', index);
    // console.log('handleSetContentFile: ', state);
    // console.log('handleSetContentFile: ', imageInfo);
    const findFile = (content || []).find(
      (item) => item?.index === index && item?.src === imageInfo?.src
    );

    if (!!findFile) {
      return content;
    }

    // if (["delete", "update"].includes(state) && sunEditorRef?.current?.editor?.getContents?.()) {
    //   handleChange(sunEditorRef.current.editor.getContents());
    // }

    const data: any = {
      index,
      name: imageInfo?.name,
      src: imageInfo?.src,
      status: state,
    };

    if (imageInfo?.src.includes("/9j/4AAQ")) {
      data.file = dataURLtoFile(imageInfo.src, "image.jpg");
    } else if (imageInfo?.src.includes("iVBORw0KGg")) {
      data.file = dataURLtoFile(imageInfo.src, "image.png");
    }

    return [...content, data];
  };

  const versionsOptions = useMemo(() => {
    let versions: any[] = [];
    console.log("versions: ", versions);
    if (props.version) {
      console.log("props.version: ", props.version);
      versions = new Array(Number(props.version)).fill(1);
      console.log("1 versions: ", versions);
      versions = versions.map((i, idx) => ({
        key: idx + 1,
        value: idx + 1,
        text: `Version ${idx + 1}`,
      }));
      console.log("2 versions: ", versions);
    }
    console.log("3 versions: ", versions);
    return versions;
  }, [props.version]);

  const getContentSummary = () => {
    if (!props.content) {
      return "";
    }

    // ลบ HTML tags และแสดงเฉพาะ text
    const plainText = props.content.replaceAll(/<[^>]*>/g, "");

    return plainText.length > 40 ? `${plainText.slice(0, 40)}...` : plainText;
  };

  const saveAtUTC = props.publishJson?.metadata?.saved_at
    ? (props.publishJson?.metadata?.saved_at as string).endsWith("Z")
      ? props.publishJson?.metadata?.saved_at
      : props.publishJson?.metadata?.saved_at + "Z"
    : "";

  return (
    <Card fluid>
      <CardContent>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            gap: "4px",
            justifyContent: "space-between",
            marginBottom: "6px",
          }}
        >
          <div>
            {/* { props.publishedAt ? <Label size="tiny" color="orange">
              Publish (Version: {props.publishedVersion}): {moment(props.publishedAt.toDate()).format(`YYYY/MM/DD [[]HH:mm[]]`)}
          </Label> : null }  */}
            {!isExpanded && (
              <span style={{ fontSize: "1.35rem", fontWeight: "bold" }}>{getContentSummary()}</span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <div>{props.id}</div>
            {/* <div><Dropdown
              selection
              value={version}
              disabled={version === undefined}
              onChange={(e, {value}) => {
                console.log(" value : ", value)
                setVersion(value as number)
                props.runSequence({
                  sequence: "SegmentTarget",
                  action: "GetPublicContents",
                  id: props.id,
                  version: value,
                  type: POST,
                })
              }}
              options={versionsOptions}
            /></div> */}

            {/* { version === props.version ? <>
              { (version !== undefined) && (version === props.publishedVersion) ? (
                <div style={{ marginBottom: "3px" }}>
                  <Label size="tiny" color="orange">
                    Publish
                  </Label>
                </div>
              ) : (
                <div style={{ marginBottom: "3px" }}>
                  <Label size="tiny" color="grey">
                    No Publish
                  </Label>
                </div>
              ) }
            </> : <>
              { saveAtUTC ? <div style={{ marginBottom: "3px" }}>
                <Label size="tiny" color="pink">
                  Had Been Published {moment(saveAtUTC).format(`YYYY/MM/DD [[]HH:mm[]]`)}
                </Label>
              </div> : null }
            </>} */}
            {props.publishedAt ? (
              <Label size="tiny" color="orange">
                Publish: {moment(props.publishedAt.toDate()).format(`YYYY/MM/DD [[]HH:mm[]]`)}
              </Label>
            ) : (
              <Label size="tiny" color="grey">
                Not publish
              </Label>
            )}
          </div>
        </div>

        {!isExpanded && (
          <Form style={{ borderBottom: "1px solid #eee", padding: "5px 0 10px" }} size="small">
            <div style={{ color: "#999" }}>Edit by : {props.updatedBy?.name}</div>
            <div style={{ color: "#999" }}>
              Last edit : {formatDatetime(props.updatedAt?.toDate(), true)}
            </div>
            <div style={{ color: "#999" }}>
              Post date : {formatDatetime(props.publishedAt?.toDate(), true)}
            </div>
          </Form>
        )}

        {isExpanded && (
          <>
            {version === props.version ? (
              <Form>
                <FormField>
                  <SunEditor
                    height="100%"
                    autoFocus={false}
                    // plugin=""
                    key={"sun-editor" + props.id}
                    // setDefaultStyle={`font-size: 1.125rem; color: rgb(61, 61, 61); margin-top: 10px;`}
                    onImageUpload={handleImageUpload}
                    onImageUploadBefore={handleImageUploadBefore}
                    onImageUploadError={handleImageUploadError}
                    setContents={props.content}
                    onChange={handleChange}
                    onResizeEditor={handleOnResizeEditor}
                    setOptions={{
                      buttonList: [
                        ["formatBlock"],
                        ["blockquote"],
                        ["bold", "underline", "italic", "strike"],
                        ["fontColor", "hiliteColor"],
                        ["align", "list"],
                        ["outdent", "indent"],
                        ["horizontalRule", "image", "video", "link"],
                        ["removeFormat"],
                      ],
                      defaultTag: "div",
                      minHeight: "200px",
                      showPathLabel: false,
                    }}
                  />
                </FormField>
                <FormField>
                  <label>Tag อวัยวะ</label>
                  <Dropdown
                    fluid
                    selection
                    search
                    options={props.optionsOrgans}
                    multiple
                    clearable
                    value={props.organTags}
                    onChange={(e, data) => {
                      setIsEdit(true);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UpdateContents",
                        organTags: data.value,
                        id: props.id,
                        type: POST,
                      });
                    }}
                  />
                </FormField>
              </Form>
            ) : (
              <CardPreviewPost
                id={props.id}
                version={props.version}
                publishJson={props.publishJson}
              />
            )}
          </>
        )}
      </CardContent>

      {isExpanded && (
        <CardContent extra>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px", margin: "4px" }}>
            {props.publishedAt ? (
              <Button
                loading={props.idxUnpublishLoading === props.id}
                size="tiny"
                onClick={() => {
                  props.setModalParam({
                    open: true,
                    header: "ยืนยันการซ่อนโพสนี้",
                    content: "ยืนยันการซ่อนโพสนี้",
                    cancle: () => {
                      props.setModalParam(undefined);
                    },
                    cancleText: "ยกเลิก",
                    confirm: () => {
                      props.setModalParam(undefined);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UnPublish",
                        contentId: props.id,
                        type: POST,
                      });
                    },
                    confirmText: "ยืนยัน",
                  });
                }}
              >
                ซ่อน
              </Button>
            ) : null}
            <Button
              size="tiny"
              onClick={() => {
                props.setModalParam({
                  open: true,
                  header: "ยืนยันการลบ",
                  content: "ยืนยันการลบ",
                  cancle: () => {
                    props.setModalParam(undefined);
                  },
                  cancleText: "ยกเลิก",
                  confirm: () => {
                    props.setModalParam(undefined);
                    props.runSequence({
                      sequence: "SegmentTarget",
                      action: "DeleteContent",
                      contentId: props.id,
                      type: POST,
                    });
                  },
                  confirmText: "ยืนยัน",
                });
              }}
            >
              ลบโพสต์
            </Button>
            <Button
              size="tiny"
              loading={props.idxSaveLoading === props.id}
              disabled={!isEdit || (version !== undefined && props.publishedVersion >= version)}
              onClick={() => {
                props.runSequence({
                  sequence: "SegmentTarget",
                  action: "SaveContent",
                  id: props.id,
                  content: props.content,
                  organTags: props.organTags,
                  type: POST,
                });
                setIsEdit(false);
              }}
            >
              บันทึกร่าง
            </Button>
            <Button
              size="tiny"
              disabled={!props.isEdit}
              loading={props.idxPublishLoading === props.id}
              onClick={() => {
                props.setModalParam({
                  open: true,
                  header: "ยืนยันการโพสต์",
                  content: "ยืนยันการโพสต์",
                  cancle: () => {
                    props.setModalParam(undefined);
                  },
                  cancleText: "ยกเลิก",
                  confirm: () => {
                    props.setModalParam(undefined);
                    props.runSequence({
                      sequence: "SegmentTarget",
                      action: "Publish",
                      contentId: props.id,
                      publishedVersion: props.version,
                      type: POST,
                    });
                  },
                  confirmText: "ยืนยัน",
                });
              }}
            >
              โพสต์
            </Button>
          </div>
        </CardContent>
      )}

      {!!props.version && (
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "0px 0px 8px" }}>
          <Button
            style={{
              background: "transparent",
              border: "none",
              color: "var(--primary-theme-color)",
              padding: "0px 9px 7px 12px",
            }}
            size="small"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "View less" : "View more"}
            <Icon style={{ marginLeft: "5px" }} name={isExpanded ? "angle up" : "angle down"} />
          </Button>
        </div>
      )}
    </Card>
  );
};

export default ContentEditorPost;
